"use client";

import { isHomePage } from "@/utils/functions/global-constants";
import { usePathname } from "next/navigation";

const SvgBarHome = () => {
  const pathname = usePathname();

  const selected = isHomePage(pathname);
  return (
    <>
      {selected ? (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3958 21.2916H13.5208C12.7728 21.2916 12.1667 20.6855 12.1667 19.9375V15.0625C12.1667 14.4639 11.6819 13.9791 11.0833 13.9791H8.91667C8.31813 13.9791 7.83333 14.4639 7.83333 15.0625V19.9375C7.83333 20.6855 7.22721 21.2916 6.47917 21.2916H1.60417C0.856125 21.2916 0.25 20.6855 0.25 19.9375V9.59867C0.25 8.35338 0.820917 7.17688 1.79863 6.40663L9.49679 0.340501C9.792 0.108668 10.208 0.108668 10.5027 0.340501L18.2019 6.40663C19.1796 7.17688 19.75 8.35283 19.75 9.59758V19.9375C19.75 20.6855 19.1439 21.2916 18.3958 21.2916Z"
            className="fill-secondary"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.97355 0.166653C9.8003 0.172569 9.63349 0.233735 9.49748 0.341213L1.79883 6.4064C0.821717 7.17645 0.25 8.35314 0.25 9.59715V19.9375C0.25 20.6761 0.865553 21.2917 1.60417 21.2917H7.02083C7.75945 21.2917 8.375 20.6761 8.375 19.9375V14.5208C8.375 14.361 8.48602 14.25 8.64583 14.25H11.3542C11.514 14.25 11.625 14.361 11.625 14.5208V19.9375C11.625 20.6761 12.2406 21.2917 12.9792 21.2917H18.3958C19.1344 21.2917 19.75 20.6761 19.75 19.9375V9.59715C19.75 8.35314 19.1783 7.17645 18.2012 6.4064L10.5025 0.341213C10.3523 0.222521 10.1649 0.160699 9.97355 0.166653ZM10 2.01382L17.1961 7.68334C17.7833 8.14612 18.125 8.85001 18.125 9.59715V19.6667H13.25V14.5208C13.25 13.4836 12.3914 12.625 11.3542 12.625H8.64583C7.60857 12.625 6.75 13.4836 6.75 14.5208V19.6667H1.875V9.59715C1.875 8.85001 2.21665 8.14612 2.80387 7.68334L10 2.01382Z"
            className="fill-gray3"
          />
        </svg>
      )}
    </>
  );
};

export default SvgBarHome;
